import { fetchMerchandiseLists, fetchMerchandiseDetail } from '../api/modules/merchandise'
import { isSuccessStatus } from '../utils/http'

export default {
  namespaced: true,
  state: {
    // 商品一覧
    itemLists: [],
    // 商品詳細
    itemDetails: [],
  },
  getters: {
    itemLists: state => state.itemLists,
    itemDetails: state => state.itemDetails,
    // 対象商品の詳細取得
    findDetail: state => id => {
      return state.itemDetails.find(item => item.id == id)
    },
  },
  mutations: {
    updateLists(state, lists) {
      state.itemLists = lists
    },
    // 商品種別更新
    updateDetail(state, item) {

      const index = state.itemDetails.findIndex(i => i.id == item.id)
      const isExist = index != -1

      if (isExist) {
        // 既に存在する商品は更新
        state.itemDetails.splice(index, 1, item)
        // state.itemDetails[index] = itemだとVueに変更が検知されない
      }
      else {
        // 追加
        state.itemDetails.push(item)
      }
    },
    clearDetails(state) {
      state.itemDetails = []
    },
  },
  actions: {
    // 商品一覧を取得
    async loadItemLists({ commit, dispatch }) {

      const result = await fetchMerchandiseLists()

      if (isSuccessStatus(result.statusCode)) {
        commit('updateLists', result.response)
      }
      else {
        dispatch('error/setError', { code: result.statusCode, id: result.requestId, message: result.response }, { root: true })
      }
    },
    // 商品詳細を取得
    async loadItemDetailByKey({ commit, dispatch }, { id, priceTypeId }) {

      const result = await fetchMerchandiseDetail({ id, priceTypeId })

      if (isSuccessStatus(result.statusCode)) {
        commit('updateDetail', result.response)
      }
      else {
        dispatch('error/setError', { code: result.statusCode, id: result.requestId, message: result.response }, { root: true })
      }
    },
    // 商品詳細をクリア
    resetItemDetail({ commit }) {
      commit('clearDetails')
    },
  },
}
